import React, { CSSProperties, FC, ReactNode } from 'react'

import classes from './Padding.module.scss'

interface PaddingProps {
  size?: number
  sizeDesktop?: number
  children?: ReactNode
  className?: string
}

export const Padding: FC<PaddingProps> = ({
  size,
  sizeDesktop,
  children,
  className,
}) => {
  const style: CSSProperties & Record<string, string> = {}
  if (size !== undefined) {
    style['--padding-size'] = `${size * 0.5}rem`
  }
  if (sizeDesktop !== undefined) {
    style['--padding-size-desktop'] = `${sizeDesktop * 0.5}rem`
  }

  return (
    <div
      className={[classes.padding, className].filter(Boolean).join(' ')}
      style={style}
    >
      {children}
    </div>
  )
}

export default Padding
